import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskCpf'
})
export class MaskCpfPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}
